import { search, scrollToProducts } from "algolia-instant-search";

const { connectRatingMenu } = instantsearch.connectors;

if (!customElements.get("algolia-rating-menu")) {
  class AlgoliaRatingMenu extends HTMLElement {
    connectedCallback() {
      this.selectElements();

      let currentRefine = null;

      const customRatingMenu = connectRatingMenu(
        (renderOptions, isFirstRender) => {
          const { items, refine } = renderOptions;
          const item = items.find((i) => +i.value === 4);

          currentRefine = () => refine(4);

          if (isFirstRender) {
            this.content.appendChild(
              this.filterGroupTemplate.content.cloneNode(true),
            );
            this.content
              .querySelector(".jsFilterWrapper")
              .appendChild(this.ratingRowTemplate.content.cloneNode(true));

            this.row = this.content.querySelector(".rating-filter-row");

            this.row.addEventListener("click", (e) => {
              e.preventDefault();
              currentRefine?.();
              scrollToProducts();
            });
          }

          this.row?.classList.toggle("refined", item?.isRefined ?? false);

          const clearBtn = this.content.querySelector(".jsFilterGroupClear");
          const newClearBtn = clearBtn.cloneNode(true);
          clearBtn.parentNode.replaceChild(newClearBtn, clearBtn);

          newClearBtn.addEventListener("click", () => {
            currentRefine?.();
            scrollToProducts();
          });
          newClearBtn.classList.toggle("none", !(item?.isRefined ?? false));
        },
      );

      search.addWidgets([
        customRatingMenu({ attribute: "metafield_reviews_average" }),
      ]);
    }

    selectElements() {
      this.filterGroupTemplate = this.querySelector("template#filter-group");
      this.ratingRowTemplate = this.querySelector("template#rating-row");
      this.content = this.querySelector("#content");
    }
  }

  customElements.define("algolia-rating-menu", AlgoliaRatingMenu);
}
